import styles from './style.module.scss'

export const Error = ({ children, classNameError = '' }) => {
	return <span className={`${styles.error} ${classNameError}`}>{children}</span>
}
